"use client";

import { motion } from "framer-motion";

interface PageTemplateProps {
    title?: string;
    description?: string;
    icon?: React.ReactNode;
    children: React.ReactNode;
}

export default function PageTemplate({ title, description, icon, children }: PageTemplateProps) {
    return (
        <motion.div 
            className="bg-white/80 backdrop-blur-sm rounded-2xl p-2 border border-white/50 shadow-2xl hover:shadow-3xl transition-all duration-300"
            whileHover={{ scale: 1.01 }}
        >
            <motion.div 
                className="flex items-center justify-between mb-4"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: 0.1 }}
            >
                <div className="flex items-center gap-2 md:gap-4">
                    {icon && (
                        <motion.div 
                            className="size-8 md:size-10 bg-gradient-to-br from-blue-500 to-purple-600 rounded-md flex items-center justify-center"
                            whileHover={{ scale: 1.1, rotate: 5 }}
                            transition={{ duration: 0.2 }}
                        >
                            {icon}
                        </motion.div>
                    )}
                    {title && (
                        <motion.div
                            initial={{ opacity: 0, x: -10 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.4, delay: 0.2 }}
                            className="text-left"
                        >
                            <h3 className="text-sm md:text-lg font-bold text-gray-900">{title}</h3>
                            <p className="text-gray-600 text-[11px] md:text-sm">{description}</p>
                        </motion.div>
                    )}
                </div>
                <motion.div 
                    className="flex gap-2"
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.4, delay: 0.3 }}
                >
                    <div className="w-3 h-3 bg-red-500 rounded-full"></div>
                    <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
                    <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                </motion.div>
            </motion.div>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.4 }}
            >
                {children}
            </motion.div>
        </motion.div>
    )
}